'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _indexLocal = require('./index.local.css');

var _indexLocal2 = _interopRequireDefault(_indexLocal);

var _picker = require('./picker');

var _picker2 = _interopRequireDefault(_picker);

var _flyout = require('../../flyout');

var _flyout2 = _interopRequireDefault(_flyout);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/* eslint-disable jsx-a11y/no-static-element-interactions */


var KEY_ESC = 27;

var ColorPicker = function (_React$Component) {
  _inherits(ColorPicker, _React$Component);

  function ColorPicker(props) {
    _classCallCheck(this, ColorPicker);

    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, props));

    _this.handleKeydown = function (ev) {
      if (ev.keyCode === KEY_ESC && _this.props.hideOnEsc) {
        ev.preventDefault();

        _this.hideColorPicker();
      }
    };

    _this.state = {
      visible: _this.props.defaultColorPickerVisible
    };
    return _this;
  }

  _createClass(ColorPicker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('keydown', this.handleKeydown);
    }
  }, {
    key: 'showColorPicker',
    value: function showColorPicker() {
      if (this.props.onColorPickerShow) {
        this.props.onColorPickerShow();
      }

      this.setState({
        visible: true
      });
    }
  }, {
    key: 'hideColorPicker',
    value: function hideColorPicker() {
      if (this.props.onColorPickerHide) {
        this.props.onColorPickerHide();
      }

      this.setState({
        visible: false
      });
    }
  }, {
    key: 'handleColorChange',
    value: function handleColorChange(color) {
      this.props.onColorSelect(color);

      if (this.props.hideOnColorSelect) {
        this.hideColorPicker();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)([_indexLocal2.default.colorPickerBase, this.props.className])
      }, _react2.default.createElement('div', {
        className: this.props.theme === 'boxy' ? _indexLocal2.default.buttonWrapperBoxy : _indexLocal2.default.buttonWrapper
      }, _react2.default.createElement(_flyout2.default, {
        theme: 'light',
        position: 'right',
        label: this.props.hoverLabel
      }, _react2.default.createElement('button', {
        style: {
          backgroundColor: this.props.color
        },
        className: (0, _classnames2.default)([_indexLocal2.default.colorPickerButton, _indexLocal2.default[this.props.theme]]),
        onClick: function onClick() {
          return _this2.showColorPicker();
        }
      }, this.props.color)), this.props.label && _react2.default.createElement('span', {
        className: _indexLocal2.default.label
      }, this.props.label)), this.state.visible && _react2.default.createElement(_picker2.default, {
        color: this.props.color,
        onChangeComplete: function onChangeComplete(color) {
          return _this2.handleColorChange(color);
        }
      }, this.props.children), this.state.visible && _react2.default.createElement('div', {
        className: _indexLocal2.default.clickMask,
        onClick: function onClick() {
          return _this2.hideColorPicker();
        }
      }));
    }
  }]);

  return ColorPicker;
}(_react2.default.Component);

ColorPicker.defaultProps = {
  className: null,
  color: '',
  defaultColorPickerVisible: false,
  hideOnColorSelect: false,
  hideOnEsc: true,
  hoverLabel: 'Change color.',
  label: null,
  onColorSelect: null,
  onColorPickerHide: null,
  onColorPickerShow: null,
  theme: 'default'
};
ColorPicker.propTypes = {
  /**
   * Custom classname to prepend container element
   */
  className: _propTypes2.default.string,

  /**
   * Can be hex string, or hsl/hsv/rgb object
   */
  color: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),

  /**
   * Default state for color picker visiblity
   */
  defaultColorPickerVisible: _propTypes2.default.bool,

  /**
   * Close color picker after selection
   */
  hideOnColorSelect: _propTypes2.default.bool,

  /**
   * Close color picker when ESC key is pressed
   */
  hideOnEsc: _propTypes2.default.bool,

  /**
   * Text label to appear when hovering over color picker
   */
  hoverLabel: _propTypes2.default.string,

  /**
   * Text label to appear under button
   */
  label: _propTypes2.default.string,

  /**
   * Called when a color has been selected.
   * @returns {hsl: {}, hsv: {}, hex: '', rgb: {}, oldHue: {}, source: ''}
   */
  onColorSelect: _propTypes2.default.func,

  /**
   * Function invoked on color picker hide
   */
  onColorPickerHide: _propTypes2.default.func,

  /**
   * Function invoked on color picker show
   */
  onColorPickerShow: _propTypes2.default.func,
  theme: _propTypes2.default.string,

  /**
   * Child DOM elements to be rendered below the main color picker UX for additional app-specific features
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
};
exports.default = ColorPicker;